// extracted by mini-css-extract-plugin
module.exports = {"root":"PdfResume_root__O0aRP","webview":"PdfResume_webview__UFlYo"};